class StorageModel {
    constructor() {
        if (!window.name) 
            window.name = '{}';
    }

    SetItem(key, value) {
        let currentValues = JSON.parse(window.name);
        currentValues[key] = value;
        window.name = JSON.stringify(currentValues);
    }

    GetItem(key) {
        let currentValues = JSON.parse(window.name);
        return currentValues[key];
    }

    DeleteItem(key) {
        let currentValues = JSON.parse(window.name);
        delete currentValues[key];
        window.name = JSON.stringify(currentValues);
    }

    UpdateItem(key, value) {
        let currentValues = JSON.parse(window.name);
        currentValues[key] = value;
        window.name = JSON.stringify(currentValues);
    }

    Reset() {
        window.name = '{}';
    }
}

export var storageModel = new StorageModel();